import { create } from 'zustand';

const useDashboardPaymentCollection = create((set) => ({
  schedularDate: {},
  selectedSource: "",
   
  setSchedularDate: (val) => set({ schedularDate: val }),
  setSelectedSource: (val) => set({ selectedSource: val }),
   
}));
export default useDashboardPaymentCollection;
